import { defineCatalog } from '@json-render/core';
import { schema } from '@json-render/react/schema';
import {
  AudienceOverlapPropsSchema,
  GridPropsSchema,
  HorizontalStackedBarChartPropsSchema,
  InsightCardPropsSchema,
  LineBarChartCardPropsSchema,
  OutputCardPropsSchema,
  QuoteCardPropsSchema,
  RadioStatCardPropsSchema,
  SectionTitlePropsSchema
} from './schemas';

export const catalog = defineCatalog(schema, {
  components: {
    Grid: {
      props: GridPropsSchema,
      slots: ['default'],
      description:
        'whenToUse: Use layout "vertical" for stacked sections. Use layout "horizontal" with columns "2", "3", or "4" for side-by-side sections; nest Grid children to mix vertical and horizontal rows. Lay out InsightCard, RadioStatCard, and similar cards side by side in a horizontal Grid.'
    },
    HorizontalStackedBarChart: {
      props: HorizontalStackedBarChartPropsSchema,
      description:
        'whenToUse: Show a single horizontal stacked bar with audience percentage segments, index labels beneath each segment, and a color key in a bordered insight card.'
    },
    AudienceOverlap: {
      props: AudienceOverlapPropsSchema,
      description:
        'whenToUse: Show audience A, audience B, and their overlap from three static audience records ordered as A, B, overlap, with an optional card title and optional summary stats in a right-hand column.'
    },
    InsightCard: {
      props: InsightCardPropsSchema,
      description:
        'whenToUse: Show a single metric insight card with optional title, body copy, a prominent value, and supporting description. Lay out multiple cards side by side in a horizontal Grid.'
    },
    RadioStatCard: {
      props: RadioStatCardPropsSchema,
      description:
        'whenToUse: Show a single attitude or behaviour stat with a circular percentage ring, formatted index label, and centre-aligned description. Lay out multiple cards side by side in a horizontal Grid.'
    },
    QuoteCard: {
      props: QuoteCardPropsSchema,
      description:
        'whenToUse: Highlight a single qualitative or summary callout in a bordered quote card. Use markdown-style **double asterisks** inside text for semibold emphasis.'
    },
    OutputCard: {
      props: OutputCardPropsSchema,
      description:
        'whenToUse: Present a titled output section with introductory copy and a checklist of supporting bullet points, each prefixed with a pink check icon.'
    },
    LineBarChartCard: {
      props: LineBarChartCardPropsSchema,
      description:
        'whenToUse: Show a titled list of labelled horizontal line bars with audience percentage fill and formatted index values on the right.'
    },
    SectionTitle: {
      props: SectionTitlePropsSchema,
      description:
        'whenToUse: Place immediately above a section of related components. Use whenever the following section lacks a clear title or a section-level heading is required.'
    }
  },
  actions: {}
});
